import { render } from "./ForgotPassword.vue?vue&type=template&id=851d241e&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "./ForgotPassword.vue?vue&type=style&index=0&id=851d241e&lang=scss"
import "./ForgotPassword.vue?vue&type=style&index=1&id=851d241e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-851d241e"]])

export default __exports__